import React, { useState, useEffect, useContext } from 'react'
import TopBar from "../../scenes/global/Top-Bar";
import SideBar from "../../scenes/global/Side-Bar";
import PreviewSection from "../preview_components/preview_section";
import PersonalInfo from "../preview_components/personal";
import EducationSection from "../preview_components/education";
import WorkExperience from "../preview_components/work_experience";
import PreviewButton from "../preview_components/preview_button";
import Volunteer from "../preview_components/volunteer";
import Award from "../preview_components/award";
import Reference from "../preview_components/reference";
import JobType from "../preview_components/job_type";
import { useSelector, useDispatch } from "react-redux";
import App1 from "../../scenes/pdf/DownloadableRresume";
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { AdjustGPTResponse, AdjustExperienceDate, arrangeEducationDate } from '../../scenes/pdf/Adjust_gptRes';
import { PDFViewer, StyleSheet } from '@react-pdf/renderer';
//import language context
import { LanguageContext } from "../../scenes/global/languageContext";
import { saveCvDetails, getProfile, generate_my_cv, dispatchSpanish, spanish_loading, lang_type, lastResme } from '../../Redux/ActionCreator';
import { ToastContainer, toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { resume_step_jump_function } from '../../Redux/ActionCreator';
import { convertResumeToSpanish, convertAward, convertProfessional_summary, convertPersonalSkills, convertSkills, convertCvType, convertInterest, convertExperience, convertEducation, processValues, convert } from '../../Redux/convertResume';
import LoaderModal from '../../components/LoaderModal';
import English from '../../scenes/global/language/en';
import Spanish from '../../scenes/global/language/sp';

export default function UserPreviewDetails() {
/*   const generatedCV = useSelector(e => e.generateCV)
  const message = generatedCV.message; */

  const { language, handleLanguageChange } = useContext(LanguageContext);
  const [showDoneModal, setShowDoneModal] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
	const getMyCv = useSelector((prev) => prev.saved_cv);
	const type = useSelector((prev) => prev.type);
	const details = getMyCv.message;
  console.log("details", details);
  const [ stat, setStat ] = useState(false);
  const [ clicked, setClicked ] = useState(false);
  const [ saveBtn, setSaveBtn ] = useState("");
  const [ showEditBtn, setShowEditBtn ] = useState(false);

  // get the id parameter if any
  const idParams = new URLSearchParams(window.location.search).get("id");
  console.log("idParams", idParams);
  const param = useParams();
  console.log("param", param)
  const update_status = new URLSearchParams(window.location.search).get("stat")
  // state to determine the if the link button should be displayed or not
  const [ display, setDisplay ] = useState(false);
  // initialize useSelector hook
  const saved_cv_details = useSelector(prev => prev.saved_cv);
  const current_details = useSelector(details => details.generateCV)
  const ex_cv = useSelector(details => details.existingCV);
  const sp = useSelector(s => s.spanish);
  const profile = useSelector(e => e.login);
  const userInfo = useSelector(e => e.userInfo);
  let log_stat = profile.profile_status.profile_status; // login status
  const cv_id = useSelector(prev => prev.cvId);
  const [ text, setText ] = useState("English");
  const [ a, setA ] = useState(false);
  let id;
  if (idParams === null) {
    id = cv_id.id;
  } else {
    id = idParams;
  }
  console.log("idd", id);

  let cv_details;
  if (current_details.message === null) {
    let filterById = []
    if (saved_cv_details.message !== null && saved_cv_details.message !== undefined) {
      saved_cv_details.message.forEach(prev => {
        if (prev._id === param.cvID) {
          console.log("prev", prev)
          filterById.push(prev);
        }
      });
      console.log("filterById", filterById)
      cv_details = { message: filterById[0]};
    }
  } else {
    cv_details = { message: current_details.message};
  }

  // editing start
  cv_details.message = AdjustGPTResponse(cv_details.message, id); // edit possible error from gpt

  // education date arrangement

  cv_details.message.Education = arrangeEducationDate(cv_details.message.Education);

  cv_details.message.Experience = AdjustExperienceDate(cv_details.message.Experience)

/*   const yourSecret = localStorage.getItem("secret");
  // Retrieve the "payment_intent_client_secret" query parameter appended to
  // your return_url by Stripe.js
  const clientSecret = new URLSearchParams(window.location.search).get(
    'payment_intent_client_secret'
  ); */

  const [ status, setStatus ] = useState(true);

  useEffect(() => {
    if (update_status === "cannot update") {
      setShowEditBtn(true);
    }
  }, []);
  console.log("showEditBtn", showEditBtn);

  useEffect(() => {
    
    if (type.type === "Spanish") {
      setText("English");
      dispatch(lang_type("English"))
    } else if (type.type === "English") {
      setText("Spanish");
      dispatch(lang_type("Spanish"));
    }
  }, [])

  useEffect(() => {
    console.log("cv_detail", cv_details);

    if (window.location.pathname.includes("/allCv")) {
      setSaveBtn("Save and print resume");
    } else {
      setSaveBtn("Print resume");
    }


/*     if (yourSecret === clientSecret) {
      setStatus(true);
    }
*/

/*     if (cv_details.message.Secret !== null && cv_details.message.Secret !== undefined) {
      setStatus(true);
    }
     */
    if (window.outerWidth <= 567) {
      setDisplay(true)
    }
  }, [window.location.pathname.includes("/allCv")], stat);

  const handleClick = () => {
    setClicked(true);
      // check if cv_details is not null, if it is not, post the cv_details to the database.
    if (cv_details.message.Secret === undefined) {
      const clientSecret = uuidv4();
      cv_details.message.Secret = clientSecret;
      // post here
      if (log_stat === "true") {
        dispatch(saveCvDetails(cv_details.message, id, clientSecret ));
      }
    }
  }

  const handleProfileView = () => {
    if (window.location.pathname !== "/allCv") {
      dispatch(getProfile(localStorage.getItem("token")));
      navigate(`/user/profile/:${userInfo.user.profile_id}`);
    } else {
      if (clicked !== true) {
        setTimeout(() => {
          toast.error("You must save your resume before you can view your  status.", {
              position: toast.POSITION.TOP_RIGHT,
          });
        }, 50);
      } else {
        dispatch(getProfile(localStorage.getItem("token")));
        dispatch(lastResme(cv_details.message));
        navigate(`/user/profile/:${userInfo.user.profile_id}`);
      }
    }
  }

	const hideDoneModal = () => {
		setShowDoneModal(false);
	};

  const handleSpanish = async (arg) => {
    dispatch(spanish_loading(true));
    setStat(true);
    console.log("texttt", text)
    let lan;
    if (text === "English") {
      lan = "Latin American Spanish"
      setText("Spanish");
    } else if (text === "Spanish") {
      lan = "English";
      setText("English");
    }
    const final_arg = {...arg, "Lang": [{lang: lan}] }
    dispatch(convert(final_arg));
  }
  console.log("Text", text)
  const styles = StyleSheet.create({

    viewer: {
      marginTop: 10,
      width: '65vw', height: '100vh',
       '@media max-width: 700' : {
        width: "55vw", height: "60vh"
      }
    },
  });

  console.log("Update status", update_status);

  const handleJumpToPage = (pageIndex) => {
    if (update_status == "cannot update") {
      setTimeout(() => {
        toast.error("You cannot update an existing resume. Kindly create another one.", {
            position: toast.POSITION.TOP_RIGHT,
        });
    }, 50);
    } else {
      navigate(`/form/${cv_id.id}/update`)
      dispatch(resume_step_jump_function(pageIndex));
    }
  }


  return (

    <div className="grid grid-cols-auto md:grid-cols-smdash cont:grid-cols-dash grid-rows-dash">
      <TopBar topBarShowMenu={true} />
      <SideBar />
      {
        cv_details.message !== null ? 
        <div className="pl-3 flex flex-col gap-12 max-w-[800px]">
        <div className="flex-col justify-start items-start inline-flex pl-3 mt-7">
          <p className="PreviewYourDetails text-stone-950 text-[28px] font-semibold">
            Preview your details
          </p>
          <p className="text-zinc-500 text-base font-normal">
            Preview the information and click on the edit button to make changes
            to a section.
          </p>
        </div>
        <div className="border-t border-black border-opacity-20 py-8 flex flex-col gap-y-6">
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 bg-slate-50 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Personal Information" stat={showEditBtn} handleJumpToPage={() => handleJumpToPage(0)}/>
            <div className="max-[768px]:w-full flex flex-col md:flex-row gap-x-8 gap-y-4 md:gap-y-6 flex-wrap">
              <PersonalInfo field="Full name:" value={cv_details.message.Fullname} />
              <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <PersonalInfo
                field="Email address:"
                value={cv_details.message.Email}
              />
              <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <PersonalInfo field="Phone number:" value={cv_details.message.Phone_number} />
              <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <PersonalInfo field="LinkedIn Profile:" value={cv_details.message.Linkedin} />
              <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <PersonalInfo field="Website:" value={cv_details.message.Website} />
            </div>
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Education" stat={showEditBtn}  handleJumpToPage={() => handleJumpToPage(1)}/>
            <div className="max-[768px]:w-full flex flex-col md:flex-row gap-x-8 gap-y-4 md:gap-y-6flex-wrap">
              {Array.isArray(cv_details.message.Education) === true ? 
                <>
                {cv_details.message.Education?.map((data, key) => (
                  <EducationSection
                    course={data.Course}
                    institution={data.School}
                    startYear={data.Start_date}
                    endYear={data.End_date}
                    key={key}
                  />
                ))}
                </>
                : 
              null }
              {/* 
              <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <EducationSection
                course="Hospitality Management"
                institution="Obafemi Awolowo University"
                startYear="2013"
                endYear="2017"
              /> */}
            </div>
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 bg-slate-50 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Work Experience" stat={showEditBtn}  handleJumpToPage={() => handleJumpToPage(2)}/>
            <div className="max-[768px]:w-full flex flex-col md:flex-row gap-x-8 gap-y-4 md:gap-y-6 flex-wrap">
              {Array.isArray(cv_details.message.Experience) === true ? 
                <>
                {cv_details.message.Experience?.map((data, key) => (
                  <WorkExperience
                    institution={data.Where_i_worked}
                    jobTitle={data.My_job_title}
                    startDate={data.Work_start_date}
                    endDate={data.Work_end_date}
                    roles={[
                      ...data.Day_to_day_work
                    ]}
                  />
                ))}
                </>
                :
                null
              }
              {/* <WorkExperience
                institution="Atlantic View Hotel and Lounge "
                jobTitle="Chief Supervisor"
                startDate="January 2018"
                endDate="July 2020"
                roles={[
                  "I organized the purchase and distribution of relief materials during COVID-19 pandemic.",
                  "I facilitated partnership with another NGO to reach the affected households.",
                ]}
              /> */}
              {/* <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div> */}
              {/* <WorkExperience
                institution="Atlantic View Hotel and Lounge "
                jobTitle="Chief Supervisor"
                startDate="January 2018"
                endDate="July 2020"
                roles={[
                  "I organized the purchase and distribution of relief materials during COVID-19 pandemic.",
                  "I facilitated partnership with another NGO to reach the affected households.",
                ]}
              />
              <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <WorkExperience
                institution="Atlantic View Hotel and Lounge "
                jobTitle="Chief Supervisor"
                startDate="January 2018"
                endDate="July 2020"
                roles={[
                  "I organized the purchase and distribution of relief materials during COVID-19 pandemic.",
                  "I facilitated partnership with another NGO to reach the affected households.",
                ]}
              /> */}
            </div>
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Skills & Licensing" stat={showEditBtn}  handleJumpToPage={() => handleJumpToPage(3)}/>
            <div className="max-[768px]:w-full flex md:flex-row gap-x-3 gap-y-4 md:gap-y-6 flex-wrap">
              {Array.isArray(cv_details.message.Technical_skills) === true ? 
              <>{cv_details.message.Technical_skills?.map((data, key) => (
                <>{data.value ? <PreviewButton text={data.value} key={key} /> : <PreviewButton text={data} key={key} />}</>
              ))}</> :
              null }
            </div>
            <div className="max-[768px]:w-full flex flex-col gap-x-3 gap-y-4 md:gap-y-6">
              <p className="text-stone-500 text-base font-semibold">
                Soft Skills
              </p>
              <div className="flex md:flex-row gap-x-3 gap-y-4 md:gap-y-6 flex-wrap">
              {Array.isArray(cv_details.message.Personal_skills) === true && cv_details.message.Personal_skills !== null ? 
              <>{cv_details.message.Personal_skills?.map((data, key) => (
                <>{data.value ? <PreviewButton text={data.value} key={key}/> : <PreviewButton text={data} key={key}/>}</>
              ))}</> :
              null }
              </div>
            </div>
            {/* <div className="max-[768px]:w-full flex flex-col gap-x-3 gap-y-4 md:gap-y-6 flex-wrap">
              <p className="text-stone-500 text-base font-semibold">
                Certifications obtained
              </p>
              <div className="flex md:flex-row gap-x-3 gap-y-4 md:gap-y-6 flex-wrap">
                <PreviewButton text="Institute of Surveyors" />
                <PreviewButton text="ICAN" />
                <PreviewButton text="NARS" />
              </div>
            </div> */}
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Volunteer Experience" stat={showEditBtn} handleJumpToPage={() => handleJumpToPage(4)}/>
            <div className="max-[768px]:w-full flex flex-col md:flex-row gap-x-8 gap-y-4 md:gap-y-6 flex-wrap">
              {
                cv_details.message.Volunteer?.map((data, key) => (
                  <Volunteer
                    // jobTitle="Logistics Coordinator"
                    institution={data.Volunteer_Org}
                    /* roles={[
                      "I organized the purchase and distribution of relief materials during COVID-19 pandemic.",
                      "I facilitated partnership with another NGO to reach the affected households.",
                    ]} */
                    year={data.Volunteer_join_date}
                  />
                ))
              }
              {/* <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <Volunteer
                jobTitle="Logistics Coordinator"
                institution="Possi Charity Foundation for the Disabled"
                roles={[
                  "I organized the purchase and distribution of relief materials during COVID-19 pandemic.",
                  "I facilitated partnership with another NGO to reach the affected households.",
                ]}
                year="2020"
              /> */}
            </div>
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Award and Honors" stat={showEditBtn}  handleJumpToPage={() => handleJumpToPage(5)} />
            <div className="max-[768px]:w-full flex flex-col md:flex-row gap-x-8 gap-y-4 md:gap-y-6 flex-wrap">
              
              {Array.isArray(cv_details.message.Award) === true ?
              <>
                {cv_details.message.Award?.map((data, key) => (
                  <Award
                    awardFrom={data.Award_giver}
                    awardName={data.Award_name}
                    // awardTitle="Most Versatile Contributor"
                    year={data.Award_year}
                  />
                ))}
              </> :
              null}

              {/* <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <Award
                awardFrom="Possi Charity Foundation for the Disabled"
                awardName="Possi Honors and Recognition"
                awardTitle="Most Versatile Contributor"
                year="2020"
              /> */}
            </div>
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Reference" stat={showEditBtn} handleJumpToPage={() => handleJumpToPage(6)}/>
            <div className="max-[768px]:w-full flex flex-col md:flex-row gap-x-8 gap-y-4 md:gap-y-6 flex-wrap">
              {
                cv_details.message.Reference?.map((data, key) => (
                  <Reference
                    refreeName={data.Reference_person_name}
                    refreeRelation={data.How_do_i_know_this_person}
                    refreeInstititution={data.Referencee_job_title}
                    refreePhone={data.Reference_phone_number}
                    refreeEmail={data.Reference_email}
                  />
                ))
              }
              {/* <div className="w-full md:w-[1px] max-[768px]:h-[1px] md:h-auto bg-indigo-400 bg-opacity-35"></div>
              <Reference
                refreeName="Dr. Kosin Maraday"
                refreeRelation="Senior Colleague and Mentor"
                refreeInstititution="Consultant, University College Hospital"
                refreePhone="+2347033161626"
                refreeEmail="officialbiodun@gmail.com"
              /> */}
            </div>
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Job Type" stat={showEditBtn} handleJumpToPage={() => handleJumpToPage(8)} />
            <div className="max-[768px]:w-full flex flex-col md:flex-row gap-x-8 gap-y-4 md:gap-y-6 flex-wrap">
              <JobType jobType={cv_details.message.CvType} experience={cv_details.message.year_of_experience} />
            </div>
          </div>
          <div className="max-[768px]:w-full max-[768px]:px-3 md:px-6 py-6 rounded-[10px] flex-col justify-start items-start gap-6 inline-flex">
            <PreviewSection header="Professional Summary" stat={showEditBtn} handleJumpToPage={() => handleJumpToPage(8)}/>
            <div className="text-justify text-black text-opacity-90 text-xs font-normal">
              {cv_details.message.Professional_summary}
            </div>
          </div>
          <h6 className='px-6'>Click on the spanish button to translate you resume into spanish.</h6>
          <div className="justify-between items-start gap-8 flex flex-wrap px-6">
            <button className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-center items-start gap-2.5 flex sm:max-w-[200px] w-full" onClick={() => handleSpanish(cv_details.message)}>
              <span className="text-center text-orange-500 text-xs sm:text-base font-semibold">
                {text === "English" ? <p>Spanish</p>: <p>English</p>}
              </span>
            </button>
            <App1 details={cv_details.message} onClick={handleClick} id={`${id}`} text={saveBtn} />
            {/* <button className="px-5 py-3 bg-indigo-700 rounded-lg shadow justify-start items-start gap-2.5 flex">
              <span className="text-center text-white text-xs sm:text-base font-semibold">
                Save and Print Resume
              </span>
            </button> */}
            <button className="px-5 py-3 rounded-lg shadow border border-orange-500 justify-start items-start gap-2.5 lg:flex sm:max-w-[200px] w-full" onClick={() => handleProfileView()}>
              <span className="text-center text-orange-500 text-xs sm:text-base font-semibold">
                View my profile
              </span>
            </button>
          </div>
          <ToastContainer />
          {stat === true ? sp.spanish !== null ? <>{() => (setStat(false), setA(!a) )}</> : <LoaderModal text={`Translating resume into ${text}`} /> : null}
        </div>
      </div> : <div>No value yet.</div>
      }
    </div>
  );
}